import type { IFetchOptions, IResponse } from '~/types/repositories';

import type { DaDataApi } from 'dadata-api';

import AbstractFetch from '~/repositories/AbstractFetch';

export default class DaData extends AbstractFetch {
  private static ADDRESS_API_URL = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address';

  private keys: { secret: string; token: string };

  constructor(fetchOptions: IFetchOptions, keys: { secret: string; token: string }) {
    super(fetchOptions.baseURL, fetchOptions.fetch);

    this.keys = keys;
  }

  async findCity(payload: { query: string; country?: string }): Promise<{ suggestions: Array<DaDataApi.Suggestion<DaDataApi.Address>> }> {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Token ' + this.keys.token,
      'X-Secret': this.keys.secret,
    };

    // Маппинг стран на ISO коды для DaData
    const countryToIsoCode: Record<string, string> = {
      Россия: 'RU',
      Беларусь: 'BY',
      Казахстан: 'KZ',
    };

    // Формируем тело запроса
    const requestBody: any = {
      query: payload.query,
      count: 10,
      from_bound: {
        value: 'city',
      },
      to_bound: {
        value: 'city',
      },
    };

    // Добавляем фильтр по стране, если указана
    if (payload.country && countryToIsoCode[payload.country]) {
      requestBody.locations = [
        {
          country_iso_code: countryToIsoCode[payload.country],
        },
      ];
    }

    return this.$fetch(DaData.ADDRESS_API_URL, {
      method: 'POST',
      mode: 'cors',
      headers,
      body: JSON.stringify(requestBody),
      credentials: 'omit',
    });
  }

  async findAddress(payload: { query: string; country?: string; city?: string }): Promise<{ suggestions: Array<DaDataApi.Suggestion<DaDataApi.Address>> }> {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Token ' + this.keys.token,
      'X-Secret': this.keys.secret,
    };

    // Маппинг стран на ISO коды для DaData
    const countryToIsoCode: Record<string, string> = {
      Россия: 'RU',
      Беларусь: 'BY',
      Казахстан: 'KZ',
    };

    // Формируем тело запроса
    const requestBody: any = {
      query: payload.query,
      count: 10,
      from_bound: {
        value: 'street',
      },
      to_bound: {
        value: 'house',
      },
    };

    // Добавляем фильтр по стране, если указана
    if (payload.country && countryToIsoCode[payload.country]) {
      requestBody.locations = [
        {
          country_iso_code: countryToIsoCode[payload.country],
        },
      ];

      // Если указан город, добавляем его в фильтр
      if (payload.city) {
        requestBody.locations[0].city = payload.city;
      }
    }

    return this.$fetch(DaData.ADDRESS_API_URL, {
      method: 'POST',
      mode: 'cors',
      headers,
      body: JSON.stringify(requestBody),
      credentials: 'omit',
    });
  }

  /**
   * @deprecated
   */
  async findStreetHouse(payload: { query: string }): Promise<{ suggestions: Array<DaDataApi.Suggestion<DaDataApi.Address>> }> {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Token ' + this.keys.token,
      'X-Secret': this.keys.secret,
    };

    return this.$fetch(DaData.ADDRESS_API_URL, {
      method: 'POST',
      mode: 'cors',
      headers,
      body: JSON.stringify({
        query: payload.query,
        locations: [
          {
            region_iso_code: 'RU-KGD',
          },
        ],
        from_bound: { value: 'street' },
        to_bound: { value: 'house' },
      }),
      credentials: 'omit',
    });
  }

  /**
   * @deprecated
   */
  async findFlat(payload: { query: string }): Promise<{ suggestions: Array<DaDataApi.Suggestion<DaDataApi.Address>> }> {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Token ' + this.keys.token,
      'X-Secret': this.keys.secret,
    };

    return this.$fetch(DaData.ADDRESS_API_URL, {
      method: 'POST',
      mode: 'cors',
      headers,
      body: JSON.stringify({
        query: payload.query,
        locations: [
          {
            region_iso_code: 'RU-KGD',
          },
        ],
        from_bound: { value: 'flat' },
        to_bound: { value: 'flat' },
      }),
      credentials: 'omit',
    });
  }
}
